
  export default {
    mounted() {
      this.onClick = (e) => {
        const plain = e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
        if (!plain || !history.state?.portalNavigated) return;
        e.preventDefault();
        e.stopPropagation();
        history.back();
      };
      this.el.addEventListener("click", this.onClick);
    },
    destroyed() {
      this.el.removeEventListener("click", this.onClick);
    }
  }
